<template>
    <v-text-field
        class="ucFirst body-2"
        :aria-label="formattedAriaLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :label="formattedLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :outlined="outlined"
        :append-icon="appendIcon"
        :value="value.trim()"
        :name="metadata.name"
        :color="$vuetify.theme.primary"
        :background-color="$vuetify.theme.primary"
        :placeholder="placeholder"
        validate-on-blur
        :data-testid="metadata.name"
        :maxlength="maxLength"
        counter
        :rules="[
            !required || requiredField(),
            v => !v || getFormRule('name')(v)
        ]"
        :data-meta-id="metadata.id"
        :id="metadata.name"
        @input="debouncedInput"
    />
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { debounce, upperFirst } from 'lodash';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';

export default {
    name: 'father-first-name',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            debouncedInput: undefined,
        };
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        appendIcon() {
            return this.withIcon ? 'far fa-user' : '';
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', this.upperFirst(value));
        },

        /**
         * Lodash upperFirst method wrapper for template
         * @param string
         */
        upperFirst(string) {
            return upperFirst(string);
        },
    },
};
</script>
